import { render } from "./VideoModal.vue?vue&type=template&id=65f9d3f6&scoped=true&ts=true"
import script from "./VideoModal.vue?vue&type=script&lang=ts"
export * from "./VideoModal.vue?vue&type=script&lang=ts"

import "./VideoModal.vue?vue&type=style&index=0&id=65f9d3f6&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src129899678/src/web-ext-ai-voucher-humelo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f9d3f6"]])

export default __exports__